export default {
  getTemplates: (state) => state.templates,
};
